export default "/images/payment-visa.png?e5d44d7b06bef078c7f71660a0dd2685";